export enum D365TokenTypes {
    HPE = 'SalesUp.AuthenticationConfiguration.Hpe',
}
